import type { ReactNode } from 'react';
import { Button } from '@monksflow/monks-ui';
import { ArrowLeftIcon } from 'lucide-react';

import { StaggerItem } from '@/shared/ui/animations';

interface BackHeaderProps {
  title: string;
  onBack?: () => void;
  actions?: ReactNode;
}

export const BackHeader = ({ title, onBack, actions }: BackHeaderProps) => (
  <header className="flex items-center justify-between gap-md rounded-lg bg-background px-md py-sm">
    <StaggerItem index={0}>
      {onBack && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="-ml-2 text-muted-foreground hover:text-foreground"
        >
          <ArrowLeftIcon />
          {title}
        </Button>
      )}
    </StaggerItem>
    {actions && (
      <StaggerItem index={1}>
        <div className="flex items-center gap-xs">{actions}</div>
      </StaggerItem>
    )}
  </header>
);
